import React from 'react';
import { useNavigate } from 'react-router-dom';
import './css/sidebar.css';
import {
  FaChevronLeft,
  FaTachometerAlt,
  FaHandsHelping,
  FaCalendarAlt,
  FaChartBar,
  FaCubes,
  FaUsers,
  FaShoppingBag,
  FaFileInvoiceDollar,
  FaUserCircle,
  FaUserTie,
  FaClock,
  FaStore,
} from 'react-icons/fa';

function Sidebar({
  isCollapsed = false,
  onToggle = () => {},
  activeView = 'dashboard',
  setActiveView = () => {},
  user = null,
}) {
  const navigate = useNavigate();
  const menuMain = [
    { key: 'dashboard',   label: 'Dashboard',   icon: <FaTachometerAlt /> },
    { key: 'calendar',    label: 'Calendar',    icon: <FaCalendarAlt /> },
    { key: 'services',    label: 'Services',    icon: <FaHandsHelping /> },
    { key: 'Products',    label: 'Products',    icon: <FaCubes /> },
    { key: 'contacts',    label: 'Contacts',    icon: <FaUsers /> },
    { key: 'manualSale',  label: 'Manual Sale', icon: <FaShoppingBag /> },
    { key: 'invoiceList', label: 'Invoices',    icon: <FaFileInvoiceDollar /> },
  ];

  const menuAdmin = [
    { key: 'team',                 label: 'Team',             icon: <FaUserTie /> },
    { key: 'Revenue',              label: 'Revenue',          icon: <FaChartBar /> },
    { key: 'EmployeeWorkingHours', label: 'Working Hours',    icon: <FaClock /> },
    // { key: '__businessSettings',   label: 'Business Details', icon: <FaStore /> },
  ];

  const menuBottom = [
    { key: 'profile', label: 'My Profile', icon: <FaUserCircle /> },
  ];

  const NavItem = ({ item }) => (
    <button
      className={`mm-menu__item ${activeView === item.key ? 'active' : ''}`}
      onClick={() => {
        if (item.key === '__businessSettings') {
          navigate('/ubd');
        } else {
          setActiveView(item.key);
        }
      }}
      title={isCollapsed ? item.label : undefined}
    >
      <span className="mm-menu__icon">{item.icon}</span>
      {!isCollapsed && <span className="mm-menu__text">{item.label}</span>}
    </button>
  );

  const userInitial = user?.name?.[0]?.toUpperCase() || 'U';
  const userRole = user?.role === 'admin' ? 'Administrator' : 'Employee';

  return (
    <aside className={`mm-sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      {/* Brand */}
      <div className="mm-sidebar__header">
        {!isCollapsed && <span className="mm-brand-name">{userRole}</span>}
        <button className="mm-collapse-btn" onClick={onToggle} aria-label="Collapse sidebar">
          <FaChevronLeft />
        </button>
      </div>

      {/* Main nav */}
      <div className="mm-nav-main">
        {!isCollapsed && <div className="mm-section-label">MAIN</div>}
        <nav className="mm-menu">
          {menuMain.map(item => <NavItem key={item.key} item={item} />)}
        </nav>

        {user?.role === 'admin' && (
          <>
            {!isCollapsed && <div className="mm-section-label">MANAGEMENT</div>}
            <nav className="mm-menu">
              {menuAdmin.map(item => <NavItem key={item.key} item={item} />)}
            </nav>
          </>
        )}
      </div>

      {/* Bottom nav + user card */}
      <div className="mm-nav-bottom">
        {!isCollapsed && <div className="mm-section-label">ACCOUNT</div>}
        <nav className="mm-menu">
          {menuBottom.map(item => <NavItem key={item.key} item={item} />)}
        </nav>

        <div className="mm-usercard">
          <div className="mm-usercard__avatar">{userInitial}</div>
          {!isCollapsed && (
            <div className="mm-usercard__info">
              <div className="mm-usercard__name">{user?.name || 'User'}</div>
              <div className="mm-usercard__role">{userRole}</div>
            </div>
          )}
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;
